// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

const formatRegulatory = r => {
  const asr = r.asr || null
  const callSign = r.callSign || null
  const licenseBasisId = castToFloat(r.licenseBasisId)
  const radioServiceId = castToFloat(r.radioServiceId)
  const stationClassId = castToFloat(r.stationClassId)

  return {
    asr,
    callSign,
    licenseBasisId,
    radioServiceId,
    stationClassId,
  }
}

export default formatRegulatory
